export const iconFontAwesomeAutomotiveTruckPickup = (
	<i className="fa-solid fa-truck-pickup"></i>
);
